import React from 'react';
import { useBrand } from '../../../app/config/brand';

interface SectionTitleProps {
  children: React.ReactNode;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({ children }) => {
  const brand = useBrand();
  return <h2 className="text-lg font-semibold mb-3" style={{ color: brand.colors.link }}>{children}</h2>;
};
